<template>
  <section
    class="banner"
    :style="componentStyle"
  >
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-sm-10 col-lg-8">
          <div
            class="banner__content"
            :style="{ 'color': componentStyle.color }"
          >
            <app-content
              class="editor__page title__h1"
              :content="translate(title)"
            />

            <app-content
              class="editor__page"
              :content="translate(text)"
            />

            <app-link
              :link="button"
              :style="buttonStyle"
              class="margin__t--48 btn btn__size--medium btn__color--prim"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useStyle } from '@/composables/app/useStyle'
import { useI18n } from '@/vendors/i18n'

import AppLink from '&/atoms/AppLink'
import AppContent from '&/atoms/AppContent'

const { section } = defineProps({
  section: {
    type: Object,
    required: true
  }
})

const { componentStyle, buttonStyle } = useStyle(section.style)
const { translate } = useI18n()

const { title, text, button } = section.attributes
</script>

<style lang="scss" scoped>
.banner {
  padding: 24px;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 200px;
  display: flex;
  align-items: center;

  @include mq(md) {
    padding: 48px;
    min-height: 500px;
  }

  &__content {
    display: flex;
    flex-direction: column;

    &:deep(.btn) {
      align-self: flex-start;
    }
  }
}

.title {
  &__h1 {
    font-size: rem(42px);

    @include mq(md) {
      font-size: rem(60px);
    }
  }
}
</style>
